/**
 * Global Config
 */
const config = {};

// Domains
config.domains = {};
config.domains.api = 'https://uxtxnxitd7.execute-api.ca-central-1.amazonaws.com/api/';
config.domains.marketing = 'https://reciprocitytrusts.ca';

// Stripe - Region-specific accounts
config.stripe_publishable_key_rgn5 = 'pk_live_YFc00Tv5meEQIfbkzv0oZSkK00QopZwQeV';
config.stripe_publishable_key_rgn3 = 'pk_live_51S5CFlPqYNUgIhhi3vdUmhK0RwGeXEuHg8DBayqCJuTSd3mrGM6lystv3tQq3eqkkDRZsQY0EVljykIFOxjt9Fjg00qwqkscWM';

// Asset base URL for S3 or CDN
config.assets_base_url = 'https://da7oblvxb9l31.cloudfront.net/assets';

// Region Payment Configuration
// Set which regions should collect payments (true) vs pledge-only (false)
// Use isPaymentRegion() helper from utils/helpers.js to check payment status
config.region_payment_enabled = {
  rgn_0: false, // Outside BC - always pledge only
  rgn_1: false, // RFT - pledge only
  rgn_2: false, // Kootenay - pledge only
  rgn_3: false, // Mainland - set to true when backend ready for payments
  rgn_4: false, // Okanagan - pledge only
  rgn_5: true, // Vancouver Island - PAYMENT ENABLED
};

module.exports = config;
